import axios from "axios"
const jsonConfig = require("../Config.json");

export const getCountryFromIp =  async(ip)=>{
    try {
        let data = await axios.get(`${jsonConfig.ip_address}`)
        if(data?.data?.country){
            return data.data.country
        }
        else {
            return null
        }
    }
    catch(err){
        console.log("Error in getCountryFromIp", err)
        return null
    }

}